import {
  DESTINATION_AUTO_COMPLETE,
  FILLING_TRAINS_QUERY_DATA,
  SOURCE_AUTO_COMPLETE,
  STATIONS_AUTO_COMPLETE,
} from '../../constants/ActionTypes';

const INITIAL_STATE = {
  stationsAutoComplete: {},
  src: '',
  des: '',
  doj: '',
  userPreferredClass: '',
  srcStnFromCity: '',
  destStnFromCity: '',
  cmp: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case STATIONS_AUTO_COMPLETE: {
    return {
      ...state,
      stationsAutoComplete: action.payload.stationsAutoCompleteResponse,
    };
  }
  case SOURCE_AUTO_COMPLETE: {
    return {
      ...state,
      srcStnFromCity: action.payload.source,
    };
  }
  case DESTINATION_AUTO_COMPLETE: {
    return {
      ...state,
      destStnFromCity: action.payload.destination,
    };
  }
  case FILLING_TRAINS_QUERY_DATA: {
    return {
      ...state,
      src: action.payload.src,
      des: action.payload.des,
      doj: action.payload.doj,
      userPreferredClass: action.payload.userPreferredClass,
      cmp: action.payload.cmp,
    };
  }
  default:
    return state;
  }
};
